import React from "react";
import styled from "styled-components";

const Page = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  background: var(--dark060);
  color: var(--gray400);
  text-align: center;
  padding: 24px;
`;

const Message = styled.h1`
  font-size: 20px;
  font-weight: 600;
  color: var(--gray500);
  margin: 0;
`;

const SignInLink = styled.a`
  color: var(--blue300);
  font-size: 15px;
  font-weight: 600;
  text-decoration: underline;

  &:hover {
    color: var(--blue400);
  }
`;

/**
 * Catch-all 404 for any path that doesn't match a known route (see AppRouter's
 * top-level `path="*"`). Deliberately NOT nested under `CustomerLayout` — a
 * full-page, layout-free treatment, since "this route doesn't exist" is a
 * different concern from any single interface's own access states (those stay
 * in-shell — see `useInterfaceAccess`/`InterfaceAccessNotice`).
 *
 * There is no token-aware branching here on purpose: an unauthenticated visitor
 * never reaches this route at all (index.tsx's pre-mount redirect to
 * app.iconik.io/search already fires for any path, this one included, before
 * the router ever mounts), so anyone actually landing on this page already has
 * a session — they just mistyped/followed a stale link. The CTA still points at
 * iconik sign-in as the one recovery path that always makes sense.
 */
const NotFoundPage = () => (
  <Page>
    <Message>Page not found.</Message>
    <SignInLink href="https://app.iconik.io">Sign in with iconik</SignInLink>
  </Page>
);

export default NotFoundPage;
